import { apiClient } from './api-client';
import { RegblData, PoiData } from '../types/index';

export const buildingInfoService = {
  /**
   * Fetch live GWR/RegBL data from Swiss GeoAdmin for a given EGID.
   * Calls GET /api/addresses/regbl/:egid
   */
  fetchRegblData: (egid: number): Promise<RegblData> =>
    apiClient.get<RegblData>(`/addresses/regbl/${egid}`),

  /**
   * Fetch nearest POIs for given WGS84 coordinates.
   * Calls GET /api/poi?lat=&lng=
   */
  fetchPois: (lat: number, lng: number, propertyId?: string, force?: boolean): Promise<PoiData> =>
    apiClient.get<PoiData>('/poi', { params: { lat, lng, ...(propertyId ? { propertyId } : {}), ...(force ? { force: 'true' } : {}) } }),
};
